/**
 * 部署后旧页面引用失效 chunk、或弱网动态 import 失败时，自动刷新一次避免白屏。
 */

var RELOAD_KEY = "__chunk_reload_ts__";
var RELOAD_GAP_MS = 15000;

export function isChunkLoadError(error) {
  if (!error) return false;
  var message = error.message || String(error);
  return (
    error.name === "ChunkLoadError" ||
    /Loading chunk [\d]+ failed/i.test(message) ||
    /Loading CSS chunk [\d]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message)
  );
}

export function reloadForChunkError() {
  try {
    var last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    var now = Date.now();
    if (now - last < RELOAD_GAP_MS) {
      return false;
    }
    sessionStorage.setItem(RELOAD_KEY, String(now));
  } catch (e) {
    // sessionStorage 不可用时仍尝试刷新
  }
  window.location.reload();
  return true;
}

/** 异步组件加载失败时重试，仍失败则触发一次整页刷新 */
export function lazyRetry(factory, retries) {
  var max = typeof retries === "number" ? retries : 2;
  return function() {
    return factory().catch(function(err) {
      if (max <= 0) {
        if (isChunkLoadError(err)) {
          reloadForChunkError();
        }
        return Promise.reject(err);
      }
      return lazyRetry(factory, max - 1)();
    });
  };
}



// WEBPACK FOOTER //
// ./src/assets/js/chunkLoad.js